import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import Modal, { ModalProps } from '@portalterreno/react-ui-core/Modal';

export type StyledModalProps = ModalProps;

const StyledModal = styled(Modal)<StyledModalProps>({
  [media('lg')]: {
    width: 410
  }
});

export default StyledModal;
